import paymentInstance from '../instance'
import paymentModalLoginInstance from '../modalLoginInstance'

const createQrPaymentSession = (totalSum, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance)
		.post('/qrPaymentSessions', { totalSum, paymentSource: 'CASH_REGISTER' })
}

export default createQrPaymentSession
